//#region src/tracking-code-input/validation/merge-diagnostics.ts
function e(e) {
	return e.code === void 0 ? `${e.line}\0${e.message}` : `${e.line}\0${e.code}`;
}
function t(e) {
	return e === "error" ? 0 : 1;
}
function n(n, r, i) {
	let a = [...n, ...r], o = /* @__PURE__ */ new Map();
	for (let t of a) o.set(e(t), t);
	let s = Array.from(o.values());
	return s.sort((e, n) => {
		if (e.line !== n.line) return e.line - n.line;
		let r = t(e.severity) - t(n.severity);
		return r === 0 ? (e.column ?? 0) - (n.column ?? 0) : r;
	}), i && (s = s.map((e) => {
		if (e.code === void 0) return e;
		let t = i[e.code];
		return t === void 0 ? e : {
			...e,
			message: t
		};
	})), {
		valid: !s.some((e) => e.severity === "error"),
		diagnostics: s
	};
}
//#endregion
export { n as mergeDiagnostics };
